const _ = require('lodash');

const getQueryParameterByName = require('../helpers/GetQueryParam');

const DanielsLoader = {
  productId: getQueryParameterByName('id'), // _.get(location.pathname.match(/([0-9]{4,})/), 1),
  configId: getQueryParameterByName('configId'),
  addToCartUrl: false
};

export default DanielsLoader;



// WEBPACK FOOTER //
// ./src/base/scripts/loaders/daniels.js